import type { RealtimeChannel, SupabaseClient } from '@supabase/supabase-js'
import type { SubscribeConnect } from '@/modules/connect/use-cases'

export class SupabaseSubscribeConnectRepository {
  constructor(private readonly client: SupabaseClient) {}

  execute: SubscribeConnect = (orgId, cb) => {
    let channel: RealtimeChannel | null = null

    const open = () => {
      channel = this.client
        .channel(`connect:${orgId}`, { config: { private: true } })
        .on(
          'broadcast',
          { event: 'message.created' },
          (m) =>
            cb({
              type: 'message',
              channelId: m.payload.channelId,
              messageId: m.payload.messageId,
            }),
        )
        .on(
          'broadcast',
          { event: 'membership_changed' },
          (m) =>
            cb({
              type: 'membership_changed',
              channelId: m.payload.channelId,
              userId: m.payload.userId,
            }),
        )
        .on(
          'broadcast',
          { event: 'announcement.created' },
          (m) =>
            cb({
              type: 'announcement',
              announcementId: m.payload.announcementId,
            }),
        )
        .subscribe()
    }

    void this.client.realtime
      .setAuth()
      .then(open)
      .catch(() => undefined)

    const { data } = this.client.auth.onAuthStateChange((event) => {
      if (event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') {
        if (channel) this.client.removeChannel(channel)
        void this.client.realtime
          .setAuth()
          .then(open)
          .catch(() => undefined)
      }
    })

    return () => {
      data.subscription.unsubscribe()
      if (channel) this.client.removeChannel(channel)
    }
  }
}
